module.exports = __webpack_public_path__ + "img/title-bg.22950c22.png";